export const LIFE = 'Life';
export const DISABILITY = 'Disability';
export const LONG_TERM_CARE = 'Long-Term Care';

export const INSURANCE_GOAL_TYPE = 'insurance';
